import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import ReactApexChart from "react-apexcharts";
import Link from "antd/es/typography/Link";

const ConsumptionVsConsumerCluster1 = () => {
  const [apexChartData, setApexChartData] = useState({});
  const [apexChartData1, setApexChartData1] = useState(null);
  useEffect(() => {
    Papa.parse("/merged_data_sum_normalized.csv", {
      download: true,
      header: true,
      complete: (result) => {
        if (result.data && result.data.length > 0) {
          // Filter the rows where 'out_*' columns have a value of 7
          const filteredGraphData = result.data.filter((row) =>
            Object.keys(row).some(
              (key) => key.startsWith("out") && row[key] === "1"
            )
          );

          if (filteredGraphData.length > 0) {
            // Extract and sort 'CONS_*' columns for the x-axis labels
            const consColumns = Object.keys(filteredGraphData[0])
              .filter((key) => key.startsWith("CONS"))
              .sort(); // Sort the columns in ascending order

            // Prepare x-axis labels by removing 'CONS_' prefix
            const labels = consColumns.map((col) => col.replace("CONS_", ""));

            // Prepare y-axis data using corresponding values of 'CONS_*' columns
            const values = consColumns.map((col) =>
              parseFloat(parseFloat(filteredGraphData[0][col]).toFixed(1))
            );

            // Set data for ApexCharts
            setApexChartData({
              options: {
                chart: {
                  id: "apexchart-example",
                  toolbar: {
                    show: false, // Disable extra toolbar for simplicity
                  },
                  title: {
                    text: "Cluster 7 Consumption",
                    align: "center",
                    style: {
                      fontSize: "18px",
                    },
                  },
                },
                xaxis: {
                  categories: labels,
                },
                markers: {
                  size: 4, // Add markers for each point on the graph
                  colors: ["#FF4560"],
                },
              },
              series: [
                {
                  name: "Cluster 7",
                  data: values,
                },
              ],
            });
          }
        }
      },
    });

    Papa.parse("/all_data.csv", {
      download: true,
      header: true,
      complete: (result) => {
        if (result.data && result.data.length > 0) {
          // Filter rows by account ID '7903853503' and 'out' value of 7
          const filteredGraphData = result.data.filter(
            (row) =>
              row.AC_ID === "5048362000" &&
              Object.keys(row).some(
                (key) => key.startsWith("out") && row[key] === "1"
              )
          );

          console.log("Filtered Data:", filteredGraphData); // Add this line to log data

          if (filteredGraphData.length > 0) {
            // Extract and sort 'CONS_*' columns for the x-axis labels
            const consColumns = Object.keys(filteredGraphData[0])
              .filter((key) => key.startsWith("CONS"))
              .sort(); // Sort the columns in ascending order

            // Prepare x-axis labels by removing 'CONS_' prefix
            const labels = consColumns.map((col) => col.replace("CONS_", ""));

            // Prepare y-axis data using corresponding values of 'CONS_*' columns
            const values = consColumns.map((col) =>
              parseFloat(parseFloat(filteredGraphData[0][col]).toFixed(1))
            );

            // Set data for ApexCharts
            setApexChartData1({
              options: {
                chart: {
                  id: "apexchart-example",
                  toolbar: {
                    show: false, // Disable extra toolbar for simplicity
                  },
                  title: {
                    text: "Consumption for Account ID 7903853503 (Cluster 7)",
                    align: "center",
                    style: {
                      fontSize: "18px",
                    },
                  },
                },
                xaxis: {
                  categories: labels,
                },
                markers: {
                  size: 4, // Add markers for each point on the graph
                  colors: ["#FF4560"],
                },
              },
              series: [
                {
                  name: "Cluster 7",
                  data: values,
                },
              ],
            });

            console.log("Apex Chart Data 1:", apexChartData1); // Add this line to log chart data
          }
        }
      },
    });
  }, []);

  return (
    <>
      {/* Delete Performance Indicator Modal */}
      <div className="modal custom-modal fade" id="delete" role="dialog">
      <div
                      className="modal-dialog modal-dialog-centered"
                      style={{ minWidth: "900px" }}
                    >
                      <div className="modal-content">
                        <div className="modal-header justify-content-center">
                          <h3 className="modal-title" id="staticBackdropLabel">
                            <b>Monthly Consumption Cluster Vs Consumer Graph</b>
                          </h3>
                         
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="card">
                             
                                <div className="card-body">
                              <b> Monthly Consumption Cluster Graph</b> 
                                  {apexChartData && apexChartData.series ? (
                                    <ReactApexChart
                                      options={apexChartData.options}
                                      series={apexChartData.series}
                                      type="line"
                                      height={235}
                                    />
                                  ) : (
                                    <div className="text-center">
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="card">
                                
                                <div className="card-body">
                              <b> Monthly Consumption Consumer Graph</b>  
                                  {apexChartData1 && apexChartData1.series ? (
                                    <ReactApexChart
                                      options={apexChartData1.options}
                                      series={apexChartData1.series}
                                      type="line"
                                      height={235}
                                    />
                                  ) : (
                                    <div className="text-center">
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                        <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                    >
                      Close
                    </Link>
                        </div>
                      </div>
                    </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};
export default ConsumptionVsConsumerCluster1;
